import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = { class: "flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", {
  class: "hidden sm:inline-block sm:align-middle sm:h-screen",
  "aria-hidden": "true"
}, "​", -1)
const _hoisted_3 = { class: "inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-md sm:w-full sm:p-6" }
const _hoisted_4 = { class: "mt-2 text-center sm:mt-5" }
const _hoisted_5 = { class: "mt-3 flex flex-col gap-y-4" }
const _hoisted_6 = { class: "text-left uppercase" }
const _hoisted_7 = ["placeholder"]
const _hoisted_8 = { class: "text-left uppercase" }
const _hoisted_9 = { class: "text-left uppercase" }
const _hoisted_10 = ["placeholder"]
const _hoisted_11 = { class: "text-left" }
const _hoisted_12 = ["placeholder"]
const _hoisted_13 = { class: "text-left uppercase" }
const _hoisted_14 = ["placeholder", "disabled"]
const _hoisted_15 = { class: "text-left uppercase" }
const _hoisted_16 = ["value"]
const _hoisted_17 = { class: "text-left uppercase" }
const _hoisted_18 = { class: "flex w-full flex-col relative" }
const _hoisted_19 = {
  key: 0,
  class: "block truncate"
}
const _hoisted_20 = {
  key: 1,
  class: "block truncate"
}
const _hoisted_21 = ["onClick"]
const _hoisted_22 = {
  key: 0,
  class: "absolute inset-y-0 left-0 flex items-center pl-3 text-amber-600"
}
const _hoisted_23 = /*#__PURE__*/_createTextVNode(" add image ")
const _hoisted_24 = { key: 0 }
const _hoisted_25 = { class: "mr-24" }
const _hoisted_26 = ["src"]
const _hoisted_27 = { class: "text-left" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Enable notifications", -1)
const _hoisted_29 = { class: "mt-5 sm:mt-6 text-center" }
const _hoisted_30 = ["disabled"]

import { formatNumber, translate } from "@/utils/tools";
import { computed, inject, onMounted, ref, watch } from "vue";
import {
  Dialog,
  DialogTitle,
  DialogOverlay,
  TransitionRoot,
  TransitionChild,
  Switch,
  Listbox,
  ListboxButton,
  ListboxOptions,
  ListboxOption,
} from "@headlessui/vue";
import DropdownComponent from "../tools/DropdownComponent.vue";
import { AxiosInstance } from "axios";
import { useStore } from "vuex";
import { fal } from "@fortawesome/pro-light-svg-icons";

export default /*#__PURE__*/_defineComponent({
  __name: 'EventCreateDialog',
  props: {
  show: Boolean,
},
  emits: ["submit", "update:show", "update:form", "created"],
  setup(__props, { emit }) {

const props = __props

const CheckIcon = require("@heroicons/vue/solid/CheckIcon");
const store = useStore();
const axios = inject("$axios") as AxiosInstance;
const showSync = computed({
  get: () => props.show,
  set: (value) => emit("update:show", value),
});
const form = ref({
  // operatorId: store.state.selectedOperator.operatorId,
  name: "",
  type: "",
  start_at: "",
  end_at: "",
  interval: undefined,
  reset_hour: undefined,
  event_reward_id: [],
  is_active: true,
  imageUrl: "",
  image_url: "",
});
const pageConfig = ref({
  page: 1,
  dataLength: 0,
  count: 0,
  pageCount: 0,
  rowsPerPage: 500,
  search: "",
  sort: [["id", "DESC"]],
});
const selectedType = ref({ label: "-Select Type-", value: null });
const selectedHour = ref({ label: "-Select Hour-", value: null });
const selectedReward = ref([]);
const dataReward = ref([]);
const isDisable = ref(false);
const isLoading = ref(false);
const file = ref();
// const addEvent: any = ref([]);

let eventType = [
  {
    label: "DAILY",
    value: "DAILY",
  },
  {
    label: "WEEKLY",
    value: "WEEKLY",
  },
  {
    label: "CUSTOM",
    value: "CUSTOM",
  },
];

let resetHour = [
  { label: "-Select Hour-", value: null },
  { label: "     0     ", value: 0 },
  { label: "     1     ", value: 1 },
  { label: "     2     ", value: 2 },
  { label: "     3     ", value: 3 },
  { label: "     4     ", value: 4 },
  { label: "     5     ", value: 5 },
  { label: "     6     ", value: 6 },
  { label: "     7     ", value: 7 },
  { label: "     8     ", value: 8 },
  { label: "     9     ", value: 9 },
  { label: "     10     ", value: 10 },
  { label: "     11     ", value: 11 },
  { label: "     12     ", value: 12 },
  { label: "     13     ", value: 13 },
  { label: "     14     ", value: 14 },
  { label: "     15     ", value: 15 },
  { label: "     16     ", value: 16 },
  { label: "     17     ", value: 17 },
  { label: "     18     ", value: 18 },
  { label: "     19     ", value: 19 },
  { label: "     20     ", value: 20 },
  { label: "     21     ", value: 21 },
  { label: "     22     ", value: 22 },
  { label: "     23     ", value: 23 },
];

const preview = ref();

const onfileSelected = async () => {
  // const reader = new FileReader();
  const formData = new FormData();
  const selectedFile = file.value.files[0];
  formData.append("file", selectedFile);
  formData.append("uploadType", "event_reward");

  try {
    const image = await uploadPic(formData);

    if (image && image.data.imageUrl) {
      form.value.imageUrl = image.data.imageUrl;
      form.value.image_url = image.data.imageUrl;
      preview.value = image.data.imageUrl;
    }
  } catch (error) {
    alert(error);
  }
};

const uploadPic = async (formData: FormData) => {
  isLoading.value = true;
  return await axios
    .post(`${process.env.VUE_APP_API_ENDPOINT}/upload/api/internal/image`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
        "x-cm-operator-id": store.state.selectedOperator.operatorId,
        "x-cm-forwarded-for": "fe-operator",
      },
    })
    .finally(() => (isLoading.value = false));
};

const onTypeSelected = (e: any) => {
  form.value.type = e.value;
  if (e.value == "DAILY") {
    isDisable.value = true;
    form.value.interval = 1;
  } else if (e.value == "WEEKLY") {
    isDisable.value = true;
    form.value.interval = 7;
  } else {
    form.value.interval = undefined;
    isDisable.value = false;
  }
};
const onHourSelected = (e: any) => {
  // console.log("onHourSelected : ",e.target.value)
  form.value.reset_hour = Number(e.target.value);
};

const fetchEventReward = async () => {
  const { page, rowsPerPage, sort, search } = pageConfig.value;
  const payload = {
    page,
    operatorId: store.state.selectedOperator.operatorId,
    name: null,
    reward_type: null,
    is_active: true,
    pageSize: rowsPerPage,
    orderBy: [sort[0]],
  };

  const url = `${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/event/api/event-rewards/list`;
  const { rows } = await axios
    .post(url, payload, {
      headers: {
        "x-cm-operator-id": store.state.selectedOperator.operatorId,
      },
    })
    .then(({ data }) => data);

  const newArray = rows.map((obj: any) => {
    return {
      id: obj.id,
      name: obj.name,
    };
  });

  dataReward.value = newArray;
  // console.log("dataReward : ", dataReward.value);
};

const onCreate = async () => {
  if (isLoading.value) return; // ป้องกันการกดปุ่มซ้ำ
  try {
    isLoading.value = true;
    await axios.post(
      `${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/event/api/events/create`,
      {
        ...form.value,
      },
      {
        headers: {
          "x-cm-operator-id": store.state.selectedOperator.operatorId,
        },
      }
    );
  } catch (error) {
    console.log(error)
  } finally {
    isLoading.value = false;
  }
  emit("created");
  clearForm();
  showSync.value = false;
};


const selecteReward = (e: any, selected: any) => {
  // console.log("select : ", e, selected);
  // console.log("event_reward_id : ",form.value.event_reward_id)

  if (form.value.event_reward_id == undefined) {
    form.value.event_reward_id = [];
  }
  if (!selected) {
    let findId = form.value.event_reward_id.find((x: any) => x.id == e.id);
    if (!findId) {
      form.value.event_reward_id.push(e.id);
    }
  } else {
    const indexOfObject = form.value.event_reward_id.findIndex((object: any) => {
      return object.id == e.id;
    });
    if (indexOfObject !== -1) {
      form.value.event_reward_id.splice(indexOfObject, 1);
    }
  }
  // console.log("(form as any).event_reward_id : ", form.value.event_reward_id);
};

const clearForm = () => {
  form.value = {
    name: "",
    type: "",
    start_at: "",
    end_at: "",
    interval: null,
    reset_hour: undefined,
    event_reward_id: [],
    is_active: true,
  };
  selectedReward.value = [];
  selectedHour.value = { label: "-Select Hour-", value: null };
  fetchEventReward();
};

// const onAddEvent = () => {
//   console.log("onAddEvent");
//   addEvent.value.push({ name: Math.random() });
//   console.log("addEvent : ", addEvent);
// };

const onClose = () => {
  clearForm();
  form.value.imageUrl = "";
  form.value.image_url = "";
  preview.value = "";
  showSync.value = false;
};


watch(showSync, (val: any) => {
  fetchEventReward();
});

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_unref(TransitionRoot), {
      as: "template",
      show: _unref(showSync),
      static: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(Dialog), {
          as: "div",
          static: "",
          class: "fixed z-10 inset-0 overflow-y-auto",
          onClose: _cache[12] || (_cache[12] = ($event: any) => (showSync.value = false)),
          open: _unref(showSync)
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createVNode(_unref(TransitionChild), {
                as: "template",
                enter: "ease-out duration-300",
                "enter-from": "opacity-0",
                "enter-to": "opacity-100",
                leave: "ease-in duration-200",
                "leave-from": "opacity-100",
                "leave-to": "opacity-0"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(DialogOverlay), { class: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" })
                ]),
                _: 1
              }),
              _hoisted_2,
              _createVNode(_unref(TransitionChild), {
                as: "template",
                enter: "ease-out duration-300",
                "enter-from": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                "enter-to": "opacity-100 translate-y-0 sm:scale-100",
                leave: "ease-in duration-200",
                "leave-from": "opacity-100 translate-y-0 sm:scale-100",
                "leave-to": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", null, [
                      _createElementVNode("div", _hoisted_4, [
                        _createVNode(_unref(DialogTitle), {
                          as: "h3",
                          class: "text-lg leading-6 font-medium text-gray-900"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t("messages.event.createEvent")), 1)
                          ]),
                          _: 1
                        }),
                        _createElementVNode("div", _hoisted_5, [
                          _createElementVNode("div", null, [
                            _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t("messages.event.name")), 1),
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.value.name) = $event)),
                              class: "rounded w-full",
                              placeholder: _ctx.$t('messages.event.name')
                            }, null, 8, _hoisted_7), [
                              [_vModelText, form.value.name]
                            ])
                          ]),
                          _createElementVNode("div", null, [
                            _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.$t("messages.event.type")), 1),
                            _createVNode(DropdownComponent, {
                              class: "w-full",
                              options: _unref(eventType),
                              modelValue: selectedType.value,
                              onOnOptionSelected: onTypeSelected
                            }, null, 8, ["options", "modelValue"])
                          ]),
                          _createElementVNode("div", null, [
                            _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.$t("messages.event.startDate")), 1),
                            _withDirectives(_createElementVNode("input", {
                              type: "date",
                              class: "rounded w-full",
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.value.start_at) = $event)),
                              placeholder: _ctx.$t('messages.event.startDate')
                            }, null, 8, _hoisted_10), [
                              [_vModelText, form.value.start_at]
                            ])
                          ]),
                          _createElementVNode("div", null, [
                            _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.$t("messages.event.endDate")), 1),
                            _withDirectives(_createElementVNode("input", {
                              type: "date",
                              class: "rounded w-full",
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.value.end_at) = $event)),
                              placeholder: _ctx.$t('messages.event.endDate')
                            }, null, 8, _hoisted_12), [
                              [_vModelText, form.value.end_at]
                            ])
                          ]),
                          _createElementVNode("div", null, [
                            _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.$t("messages.event.interval")), 1),
                            _withDirectives(_createElementVNode("input", {
                              type: "number",
                              class: "w-full rounded",
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (((form.value as any).interval) = $event)),
                              min: "1",
                              placeholder: _ctx.$t('messages.event.interval'),
                              disabled: isDisable.value
                            }, null, 8, _hoisted_14), [
                              [_vModelText, (form.value as any).interval]
                            ])
                          ]),
                          _createElementVNode("div", null, [
                            _createElementVNode("p", _hoisted_15, _toDisplayString(_ctx.$t("messages.event.resetHour")), 1),
                            _withDirectives(_createElementVNode("select", {
                              id: "location",
                              name: "location",
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((selectedHour.value.value) = $event)),
                              onChange: _cache[5] || (_cache[5] = ($event: any) => (onHourSelected($event))),
                              class: "capitalize mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm rounded-md"
                            }, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(resetHour), (item) => {
                                return (_openBlock(), _createElementBlock("option", {
                                  key: item.value,
                                  value: item.value
                                }, _toDisplayString(item.label), 9, _hoisted_16))
                              }), 128))
                            ], 544), [
                              [_vModelSelect, selectedHour.value.value]
                            ])
                          ]),
                          _createElementVNode("div", null, [
                            _createElementVNode("p", _hoisted_17, _toDisplayString(_ctx.$t("messages.event.reward")), 1),
                            _createElementVNode("div", _hoisted_18, [
                              _createVNode(_unref(Listbox), {
                                modelValue: selectedReward.value,
                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((selectedReward).value = $event)),
                                multiple: ""
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(ListboxButton), { class: "text-left appearance-none block w-full px-3 py-2 bg-white border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:management focus:border-management sm:text-sm" }, {
                                    default: _withCtx(() => [
                                      (selectedReward.value.length > 0)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(selectedReward.value.map(o => (o as any)?.name).join(", ")), 1))
                                        : (_openBlock(), _createElementBlock("span", _hoisted_20, " -Select Reward- "))
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_unref(ListboxOptions), null, {
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dataReward.value, (row) => {
                                        return (_openBlock(), _createBlock(_unref(ListboxOption), {
                                          key: row.id,
                                          value: row
                                        }, {
                                          default: _withCtx(({ active, selected }) => [
                                            _createElementVNode("li", {
                                              class: _normalizeClass(["relative py-2 px-3 hover:text-white hover:bg-indigo-600 text-gray-900 cursor-pointer select-none", [
                                  active
                                    ? '!text-amber-900 !bg-amber-100'
                                    : 'text-gray-900',
                                  'cursor-default select-none relative py-2 pl-10 pr-4',
                                ]]),
                                              onClick: ($event: any) => (selecteReward(row, selected))
                                            }, [
                                              _createElementVNode("span", {
                                                class: _normalizeClass([
                                  selected ? 'font-medium' : 'font-normal',
                                  'block truncate',
                                ])
                                              }, _toDisplayString(row.name), 3),
                                              selected
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_22, [
                                                    _createVNode(_unref(CheckIcon), {
                                                      class: "w-5 h-5",
                                                      "aria-hidden": "true"
                                                    })
                                                  ]))
                                                : _createCommentVNode("", true)
                                            ], 10, _hoisted_21)
                                          ]),
                                          _: 2
                                        }, 1032, ["value"]))
                                      }), 128))
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ])
                          ]),
                          _createElementVNode("div", null, [
                            _createElementVNode("input", {
                              type: "file",
                              ref_key: "file",
                              ref: file,
                              class: "hidden",
                              onChange: _cache[7] || (_cache[7] = ($event: any) => (onfileSelected()))
                            }, null, 544),
                            _createElementVNode("button", {
                              class: "p-1 bg-blue-400 text-white rounded",
                              onClick: _cache[8] || (_cache[8] = ($event: any) => ((_ctx.$refs.file as any).click()))
                            }, [
                              (isLoading.value)
                                ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                                    key: 0,
                                    class: "text-gray-500",
                                    icon: ['fas', 'circle-notch'],
                                    transform: "grow-6",
                                    spin: ""
                                  }))
                                : _createCommentVNode("", true),
                              _hoisted_23
                            ])
                          ]),
                          (preview.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                                _createElementVNode("p", _hoisted_25, _toDisplayString(_ctx.$t("messages.rewardCategory.previewImage")), 1),
                                _createElementVNode("img", {
                                  src: preview.value,
                                  class: "mx-auto w-52 h-52 object-contain"
                                }, null, 8, _hoisted_26)
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_27, [
                            _createTextVNode(_toDisplayString(_ctx.$t("messages.event.active")) + " ", 1),
                            _createVNode(_unref(Switch), {
                              modelValue: form.value.is_active,
                              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((form.value.is_active) = $event)),
                              class: _normalizeClass(["relative inline-flex h-6 w-11 items-center rounded-full", form.value.is_active ? 'bg-blue-400' : 'bg-red-500'])
                            }, {
                              default: _withCtx(() => [
                                _hoisted_28,
                                _createElementVNode("span", {
                                  class: _normalizeClass([form.value.is_active ? 'translate-x-6' : 'translate-x-1', "inline-block h-4 w-4 transform rounded-full bg-white"])
                                }, null, 2)
                              ]),
                              _: 1
                            }, 8, ["modelValue", "class"])
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_29, [
                      _createElementVNode("button", {
                        type: "button",
                        onClick: _cache[10] || (_cache[10] = ($event: any) => (onClose())),
                        class: "mt-3 mr-2 inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:mt-0 sm:col-start-1 sm:text-sm"
                      }, _toDisplayString(_ctx.$t("messages.event.close")), 1),
                      _createElementVNode("button", {
                        type: "button",
                        onClick: _cache[11] || (_cache[11] = ($event: any) => (onCreate())),
                        disabled: isLoading.value,
                        class: "mt-3 ml-2 inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-blue-400 text-base font-medium text-white hover:bg-blue-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:mt-0 sm:col-start-1 sm:text-sm"
                      }, _toDisplayString(_ctx.$t("messages.event.submit")), 9, _hoisted_30)
                    ])
                  ])
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }, 8, ["open"])
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}
}

})